import Pochta from "./Pochta";
function INFJ()
{
     return(
        <div className="Glavn">
  <div className='catalog' >
        <div className="image">
               <div className="image-wrapper">
      <img src="/img/INFJ Активист.png" className="INFJ"/>
      </div>
      {/* <h1>Дипломат</h1>
      <h2>ENFP</h2> */}
       <div className="result">
         <h2>INFJ</h2>
    <p><strong>Процент населения:</strong> 1–2%</p>
<p><strong>Среди мужчин:</strong> ~1%</p>
<p><strong>Среди женщин:</strong> 1–2%</p>
<p><strong>Стратегия:</strong> Вдохновение и помощь</p>

<p><strong>Психологические особенности:</strong></p>
<p>
  INFJ черпают энергию в одиночестве и глубоких размышлениях. 
  Им нужно время, чтобы осмыслить эмоции и восстановить внутренний баланс. 
  Они восстанавливают силы в тишине, вдали от людей.
</p>
<p>
  Решения INFJ принимают на основе интуиции и ценностей. 
  Они доверяют своему внутреннему голосу и глубоко чувствуют других. 
  Они ценят искренность, гармонию и возможность помогать.
</p>
<p>
  Это редкие и загадочные люди. 
  Они всегда ищут смысл и хотят изменить мир к лучшему. 
  Им трудно быть понятыми, но их видение вдохновляет других.
</p>

<p><strong>Особенность:</strong></p>
<p>
  INFJ — самые загадочные люди. Они чувствуют тебя насквозь, но сами остаются за семью замками. 
  Они могут исчезнуть без объяснений и вернуться, как ни в чём не бывало. 
  Они идеализируют людей и разочаровываются, когда те не соответствуют. 
  Их почти невозможно понять до конца — они всегда на шаг впереди.
</p>

<p>
  INFJ — это человек, который может посмотреть на тебя и понять всё: твою боль, твои страхи, твои мечты. 
  И ты никогда не узнаешь, что у него внутри.
  Их редкость делает их бесценными.
</p>

  </div>
  <Pochta/>
  </div>
   </div>
    </div>
       );
}
export default INFJ;